(function () {
	"use strict";

	angular.module("app.cart").controller("CartController", CartController);

	CartController.$inject = ["$timeout", "$q", "CartService", "ProductService", "SharedData"];

	function CartController($timeout, $q, CartService, ProductService, SharedData) {
		/* jshint validthis:true */
		var vm = this;
		vm.optionList = [];
		vm.show = false;
		vm.loading = false;
		vm.SharedData = SharedData;

		vm.getCart = function (cartType) {
			vm.loading = true;
			cartType = cartType || vm.cartType;
			var Id = $.Url.QueryString("Id", window.location.href);
			CartService.getCart({
					Id: Id,
					CartType: cartType
				})
				.then(function (_cart) {
					if (cartType == 'Compare') {
						vm.SharedData.Compare = _cart;
						vm.prepareCompareOptions();
					} else if (cartType == 'Discount') {
						vm.SharedData.Discount = _cart;
					} else if (cartType == 'Favorite') {
						vm.SharedData.Favorite = _cart;
					} else {
						vm.SharedData.Cart = _cart;
						angular.element(".mobile-badge").text(vm.SharedData.Cart.CartProduct.length);
					}
					vm.show = true;
					vm.loading = false;
				});
		};

		vm.InsertWithParams = function (params) {
			vm.loading = true;
			if (vm.SharedData.Cart) {
				params.ShipmentProviderId = vm.SharedData.Cart.ShipmentProviderId;
			}
			return CartService
				.InsertWithParams(params)
				.then(function () {
					var cartType = params.AddCartType || params.CartType;
					vm.getCart(cartType);
					vm.loading = false;
				}, function (params) {
					vm.loading = false;
					throw new Error(params.data.Code + ' : ' + params.data.Message);
				});
		};

		vm.jsonParse = function (objString) {
			return JSON.parse(objString);
		}

		vm.InsertFindedProduct = function (ProductId) {
			vm.loading = true;
			var params = {
				productID: ProductId,
				quantity: 1,
				cartId: vm.SharedData.Cart.Id
			};
			CartService.InsertWithParams(params)
				.then(function () {
					vm.searchProductKey = null;
					vm.addChartProduct = false;
					if (params.AddCartType !== "cart") {
						vm.getCart();
					}
				});
		};

		vm.IsInCart = function (params) {
			return CartService.IsInCart(params)
				.then(function (data) {
					return data;
				});
		};

		vm.Increment = function (cartProduct) {
			vm.loading = true;
			CartService.Increment(cartProduct)
				.then(function () {
					vm.getCart();
				});
		};

		vm.Decrement = function (cartProduct) {
			vm.loading = true;
			CartService.Decrement(cartProduct)
				.then(function () {
					vm.getCart();
				});
		};

		vm.updateCartProduct = function (cartProduct) {
			vm.loading = true;
			CartService.Update(cartProduct)
				.then(function () {
					vm.getCart();
				});
		}

		vm.Delete = function (cartProduct, cartType) {
			vm.loading = true;
			return CartService.Delete(cartProduct)
				.then(function () {
					if (!cartType || cartType == "Cart") {
						$.Analytics.Removo_From_Cart(cartProduct.Product);
						vm.getCart();
					} else {
						vm.loading = false;
					}
				});
		};

		vm.totalPriceWithDiscount = function () {
			if (!vm.SharedData.Cart) {
				return 0;
			}
			return _.sumBy(vm.SharedData.Cart.CartProduct, function (o) {
				return o.TotalPriceWithDiscount;
			});
		};

		vm.totalGroupPrice = function (groupedProducts) {
			return groupedProducts.reduce(function (sum, value) {
				return sum + value.Product.Price * value.Quantity;
			}, 0);
		};

		vm.totalGroupPriceWithDiscount = function (groupedProducts) {
			return groupedProducts.reduce(function (sum, value) {
				return sum + value.Product.PriceWithDiscount * value.Quantity;
			}, 0);
		};

		vm.getMainImage = function (product) {
			var mainMedia =
				product.ProductMedia.find(function (media) {
					return media.IsMain === true;
				}) ||
				product.ProductMedia[0];
			if (mainMedia) {
				return mainMedia.Media.FullPath;
			} else {
				return 'no-image.png';
			}
		};

		vm.prepareCompareOptions = function () {
			vm.optionList = [];
			$(vm.SharedData.Compare.CartProduct).each(function (i, cartProduct) {
				$(cartProduct.Product.ProductOptionValue).each(function (i, productOptionValue) {
					vm.optionList.push({
						Id: productOptionValue.Option.Id,
						Name: productOptionValue.Option.Name,
						TopOptionName: productOptionValue.Option.TopOption != null ? productOptionValue.Option.TopOption.Name : "Genel",
						Values: [],
						CustomValues: []
					});
				});
			});
			vm.optionList = vm.optionList.filter(function (value, index, self) {
				var item = self.find(function (item) {
					return item.Name == value.Name;
				});
				return self.indexOf(item) === index;
			});
			$(vm.SharedData.Compare.CartProduct).each(function (i, cartProduct) {
				$(cartProduct.Product.ProductOptionValue).each(function (i, productOptionValue) {
					var option = vm.optionList.find(function (opt) {
						return opt.Id == productOptionValue.OptionId
					});
					option.Values[cartProduct.Id] = option.Values[cartProduct.Id] || {};
					option.Values[cartProduct.Id].SubValues = option.Values[cartProduct.Id].SubValues || [];
					option.Values[cartProduct.Id].SubValues.push(productOptionValue.OptionValue.Value);
					option.CustomValues.push(productOptionValue.OptionValue.Value);
				});
			});
			$(vm.optionList).each(function (i, option) {
				option.same = option.CustomValues.every(function (val, i, arr) {
					return val === arr[0];
				});
			});
		};

		var searchTimeout;
		vm.searchProduct = function () {
			if (searchTimeout) $timeout.cancel(searchTimeout);
			vm.loadingProduct = true;
			vm.findProductList = [];
			searchTimeout = $timeout(function () {
				ProductService.searchProduct(vm.searchProductKey)
					.then(function (data) {
						vm.findProductList = data;
						vm.loadingProduct = true;
					});
			}, 500);
		}

		vm.print = function (divName) {
			var printContents = document.getElementById(divName).innerHTML;
			var popupWin = window.open('', '_blank', '');
			popupWin.document.open();
			var printContent = '<html>' +
				'<body style="padding:5px;" onload="window.print()">' + printContents + '</body>' +
				'<link href="/dist/css/mazakacore-ecommerce-lib.css"  rel="stylesheet" />' +
				'<link href="/themes/' + window.themeName + '/dist/css/site.css"  rel="stylesheet" />' +
				'<script src="/dist/js/mazakacore-ecommerce-lib.js" ></script>' +
				'<script src="/dist/js/mazakacore-ecommerce-app.js" ></script>' +
				'</html>';
			popupWin.document.write(printContent);
			popupWin.document.close();
		};

		vm.IsAllProductInStock = function () {
			if (!vm.SharedData.Cart) {
				return false;
			}
			return !vm.SharedData.Cart.CartProduct.some(function (item) {
				return item.Product.TrackStockQuantity && item.Product.ClosedForSaleIfOutOfStock && item.Product.StockQuantity < item.Quantity;
			})
		}

		function activate() {
			vm.loading = false;
			$timeout(function () {
				vm.getCart();
			});
		}

		vm.clearAll = function (cartType) {
			vm.loading = true;
			var baseCart = null;
			if (cartType == 'Compare') {
				baseCart = vm.SharedData.Compare;
			} else if (cartType == 'Discount') {
				baseCart = vm.SharedData.Discount;
			} else if (cartType == 'Favorite') {
				baseCart = vm.SharedData.Favorite;
			} else {
				baseCart = vm.SharedData.Cart;
			}
			var requests = [];
			for (var i = 0; i < baseCart.CartProduct.length; i++) {
				var cartProduct = baseCart.CartProduct[i];
				var result = CartService.Delete(cartProduct);
				if (!cartType || cartType == "Cart") {
					$.Analytics.Removo_From_Cart(cartProduct.Product);
				}
				requests.push(result);
			}
			$q.all(requests)
				.then(function () {
					vm.loading = false;
					vm.getCart();
				});
		}

		activate();
	}
})();